import { render } from "./HelpBox.vue?vue&type=template&id=2c052b6c"
import script from "./HelpBox.vue?vue&type=script&lang=js"
export * from "./HelpBox.vue?vue&type=script&lang=js"
script.render = render

export default script